import React from "react";
//home page can be changed for any page
import CenterPanelCustomerProfile from "./centerPanel";
import BottomPanelCustomerProfile from "./bottomPanel";
import { menuNamesEnum } from "../../../state/initialState";

export default function AppointmentContent(props) {
  return (
    <div>
      <div className="hidden-overflow">
        {" "}
        <div
          className={`${
            props.previousMenu == menuNamesEnum.FIRST_STEP_APPOINTMENT
              ? "appear-from-right"
              : ""
          } `}
        >
          {" "}
          <CenterPanelCustomerProfile />
        </div>
      </div>
      <BottomPanelCustomerProfile />
    </div>
  );
}
